import { Link } from 'react-router-dom';

interface VideoCardProps {
  id: string;
  title: string;
  cover: string;
  duration: string;
  views: string;
  author: string;
  authorAvatar: string;
  slug: string;
  category?: string;
}

export default function VideoCard({
  title,
  cover,
  duration,
  views,
  author,
  authorAvatar,
  slug,
}: VideoCardProps) {
  return (
    <Link
      to={`/category/${slug}`}
      className="block group cursor-pointer"
    >
      <div className="relative aspect-video rounded-lg overflow-hidden mb-3">
        <img
          src={cover}
          alt={title}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-black/10 group-hover:bg-black/20 transition-colors"></div>
        <span className="absolute bottom-2 right-2 px-2 py-0.5 bg-black/70 text-white text-xs rounded-md">
          {duration}
        </span>
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="w-12 h-12 flex items-center justify-center rounded-full bg-white/90 group-hover:bg-primary-500 group-hover:text-white transition-all duration-300 group-hover:scale-110">
            <i className="ri-play-fill text-2xl ml-0.5"></i>
          </div>
        </div>
      </div>
      <h3 className="text-sm font-medium text-foreground-900 line-clamp-2 leading-snug mb-2 group-hover:text-primary-600 transition-colors">
        {title}
      </h3>
      <div className="flex items-center gap-2">
        <img
          src={authorAvatar}
          alt={author}
          className="w-6 h-6 rounded-full object-cover"
          loading="lazy"
        />
        <span className="text-xs text-foreground-500 whitespace-nowrap">{author}</span>
        <span className="text-xs text-foreground-400 whitespace-nowrap">{views}次观看</span>
      </div>
    </Link>
  );
}